// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@vanmeter/Overrides/Widgets/Basic/Subscribe";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.wrapper = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;
        flex-wrap: wrap;
        justify-content: ${({ alignment }: any) => alignment || "center"};
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 12px;
            align-items: start;
        }
    `,
};

subscribeStyles.titleLabel = {
    variant: "h3",
    color: "common.white",
    css: css`
        margin-bottom: 0;
    `,
};

subscribeStyles.descriptionText = {
    ...fontConfig.small,
    color: "common.white",
    css: css`
        & > * {
            font-size: ${fontConfig.small.size}px;
            line-height: ${fontConfig.small.lineHeight};
            margin-bottom: 0;
        }
        max-width: 664px;
        ${xScreen("lte", "md")} {
            & > * {
                margin-bottom: 8px;
            }
            max-width: unset;
        }
    `,
};

subscribeStyles.emailButton = { variant: "secondary", buttonType: "outline", sizeVariant: "large" };

subscribeStyles.formWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        .mktoForm {
            display: flex;
            flex-direction: column;
        }
    `,
};
subscribeStyles.modalStyle = {
    messageText: {
        as: "div",
        css: css`
            display: block;
            width: 100%;
        `,
    },
    modal: {
        cssOverrides: {
            modalContent: css`
                min-height: 300px;
            `,
        },
    },
};

subscribeStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
    `,
};
